
export default {
  API_URL: 'https://localhost:5001/',
  DisableGoogleAnalytics: true,
  AUTHORIZE_NET_URL: 'https://test.authorize.net/payment/payment',
};
